import { getContacts } from '../../api';
import { useProcessedList } from '../../hooks';
import { splitSnakeCase } from '../../utilities';
import type { ContactItem, GetContactsFilters } from '../../api';

export type ItemType = ContactItem & {
  latest_contact_state_label: string;
};

const convertToItemType = (item: ContactItem): ItemType => {
  return {
    ...item,
    latest_contact_state_label: splitSnakeCase(item.latest_contact_state, {
      capitalize: true,
    }),
  };
};

const searchKeys: (keyof ItemType)[] = [
  'first_name',
  'last_name',
  'email',
  'phone',
  'latest_contact_state',
  'latest_contact_state_label',
];

const filterKeys: (keyof ItemType)[] = ['latest_contact_state'];

export const useContacts = () => {
  return useProcessedList<ItemType, GetContactsFilters>(
    async params => {
      const result = await getContacts(
        params?.filters || {},
        params?.pagination
      );

      return { content: result.map(convertToItemType) };
    },
    {
      initialSort: { name: 'email', direction: 'asc' },
      initialFilters: {
        campaignId: '',
        requiresHumanInput: '',
        latest_contact_state: undefined,
      },
      withLocalSort: true,
      withQueryParams: true,

      searchKeys,
      filterKeys,
      searchFilterKey: 'search',
    }
  );
};
